// eslint-disable-next-line @typescript-eslint/naming-convention
export type ViewType = 'grid' | 'table';

export const VIEW_TYPE_TABLE = 'table' as const;
export const VIEW_TYPE_GRID = 'grid' as const;

const listIcon = '/assets/svg/list.svg';
const gridIcon = '/assets/svg/grid.svg';

export const VIEW_TYPES = [
  {id: VIEW_TYPE_TABLE, icon: listIcon},
  {id: VIEW_TYPE_GRID, icon: gridIcon},
];
